/* eslint-disable max-lines */
import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      healthCareInstitution: {
         accountPartiallyBlocked:
            'Twoje konto zostało częściowo zablokowane z powodu nieopłaconej w terminie faktury - opłać fakturę i skontaktuj się z działem sprzedaży.',
         common: {
            purchasePackageModal: {
               close: 'Zamknij',
               content: 'W celu zwiększenia pakietu skontaktuj się z nami:',
               emailLabel: 'E-mail: <link />',
               hotlineLabel: 'Infolinia: <link />',
            },
         },
         communicationWithP1: {
            p1CertificatesForm: {
               certificateEnteredHasDifferentDataFromThatStoredOnMyPracticeView:
                  'Wprowadzony certyfikat ma inne dane od zapisanych w widoku "Moja praktyka".',
               certificateProcessingFault: {
                  CERTIFICATE_NO_LONGER_VALID: 'Certyfikat jest nieważny',
                  INVALID_CERTIFICATE_CONTAINER: 'Certyfikat jest niepoprawny',
                  INVALID_CERTIFICATE_PASSWORD: 'Hasło nie pasuje do dodanego certyfikatu',
               },
               fileUploadPlaceholder: 'Dodaj plik z rozszerzeniem .p12',
               invalidPasswordErrorMessage: 'Podaj hasło do dodanego certyfikatu',
               leavingPrompt: {
                  message:
                     'Istnieją niezapisane dane niezbędne do komunikacji z P1.\nCzy na pewno chcesz wyjść i utracić te dane?',
                  title: 'Wyjdź z edycji danych',
               },
               submissionErrors: {
                  departmentCodeNotMatch: 'Kody resortowe zawarte w certyfikatach różnią się.',
                  identifierEndsWithZero: 'Ostatnia sekwencja identyfikatora nie może być zerami.',
               },
               submit: 'Zapisz certyfikaty',
               tls: {
                  fileUploadLabel: 'Dodaj certyfikat TLS',
                  invalid: 'Brak ważnego certyfikatu TLS',
                  passwordLabel: 'Hasło do certyfikatu TLS',
                  valid: 'Posiadasz certyfikat TLS',
               },
               unavailableInDemo: 'Niedostępne w wersji demo',
               wss: {
                  fileUploadLabel: 'Dodaj certyfikat WSS',
                  invalid: 'Brak ważnego certyfikatu WSS',
                  passwordLabel: 'Hasło do certyfikatu WSS',
                  valid: 'Posiadasz certyfikat WSS',
               },
            },
            p1Identifier: {
               label: 'Identyfikator nadany przez P1',
               leavingPrompt: {
                  message:
                     'Istnieją niezapisane dane identyfikatora P1.\nCzy na pewno chcesz wyjść z ekranu "Moja praktyka" i utracić te dane?',
                  title: 'Wyjdź z Moja Praktyka',
               },
               loading: 'Wczytywanie Identyfikatora P1',
               placeholder: 'np. 2.16.840.1.113883.3.4424.2.7.00000',
               saveP1Identifier: 'Zapisz identyfikator',
               saveP1IdentifierSuccess: 'Identyfikator P1 został zmieniony.',
            },
            tabName: 'Komunikacja z P1',
            updateCertificatesSuccess: 'Certyfikaty zostały pomyślnie zaktualizowane.',
         },
         dataStorage: {
            externalDocumentation: 'Dokumentacja zewnętrzna',
            externalImportFiles: 'Pliki zewnętrzne importowane do drEryk eGabinet.',
            failedToFetchDataStorageInfo: 'Nie udało się pobrać informacji o przestrzeni na dane',
            purchasePackageButtonLabel: 'Dokup pakiet',
            purchasePackageModalTitle: 'Kup pakiet przestrzeni na dane',
            tabName: 'Przestrzeń na dane',
         },
         docplanner: {
            tabName: 'Znany Lekarz',
         },
         emergencyNotification: {
            tabName: 'Cichy alarm SOS',
         },
         generalSettings: {
            calendar: {
               header: 'Ustawienia kalendarza',
               overlappingAppointmentsAllowed: 'Możliwe rejestrowanie nakładających się wizyt',
               overlappingAppointmentsToggle: 'Możliwość rejestrowania nakładających się wizyt została zmieniona.',
            },
            confidentialitySettings: {
               header: 'Ustawienia poufności',
               hoursDeclensionMap: {
                  accusative: 'godzina',
                  genitive: 'godziny',
                  plural: 'godzin',
               },
               modal: {
                  actions: {
                     save: {
                        successMessage: 'Zmieniono czas dostępu do danych poufnych.',
                     },
                  },
                  hint: 'Możesz ustawić czas od 1 do 72 godzin.',
                  title: 'Edytuj czas obowiązywania dostępu do danych poufnych',
                  validations: {
                     range: 'Podaj wartość z zakresu od {{min}} do {{max}}.',
                  },
               },
               prescriptionIssuingAccess: {
                  description:
                     'Historia recept z wizyt poufnych jest widoczna dla użytkowników uprawnionych do przygotowywania i wystawiania recept.',
                  label: 'Dostęp do historii recept',
                  options: {
                     no: 'Nie',
                     yes: 'Tak',
                  },
                  saveOff: 'Dostęp do historii recept został wyłączony.',
                  saveOn: 'Dostęp do historii recept został włączony.',
               },
               securityLevelMap: {
                  AUTHORIZED: 'Autoryzowany',
                  MONITORED: 'Monitorowany',
               },
               table: {
                  accessDuration: 'Czas dostępu',
                  label: 'Czas obowiązywania dostępu do danych poufnych',
                  securityLevel: 'Poziom bezpieczeństwa',
               },
            },
            patientGroups: {
               header: 'Ustawienia oznaczeń pacjentów',
            },
            survey: {
               header: 'Ustawienia ankiet',
               preInterview: {
                  form: {
                     actions: {
                        cancel: 'Anuluj',
                        discardChanges: 'Odrzuć zmiany',
                        edit: 'Edytuj',
                        publish: 'Publikuj',
                        save: 'Zapisz',
                        saveAndPublish: 'Zapisz i publikuj',
                     },
                     discardChangesPrompt: {
                        actions: {
                           confirm: 'Usuń',
                        },
                        message: 'Czy chcesz usunąć nieopublikowany szablon?',
                        title: 'Przywracasz ostatnią opublikowaną wersję szablonu pre-wywiadu.',
                     },
                     errors: {
                        surveyNotUpdatableFault: 'Szablon ankiety pre-wywiadu nie został zaktualizowany.',
                        surveyTemplateVersionAlreadyPublishedFault:
                           'Szablon ankiety pre-wywiadu został już wcześniej opublikowany.',
                     },
                     fields: {
                        content: {
                           placeholder: 'Uzupełnij treść pytania...',
                        },
                     },
                     interactiveTable: {
                        buttons: {
                           addRow: {
                              disabled: 'Osiągnięto maksymalną liczbę pytań',
                              label: 'Dodaj pytanie',
                           },
                        },
                        ordinalNumber: 'L.p.',
                        questionContent: 'Treść pytania',
                     },
                     leavingPrompt: {
                        message: 'Czy chcesz wyjść z formularza? <bold>Utracisz niezapisane dane.</bold>',
                     },
                  },
                  header: 'Szablon ankiety pre-wywiadu',
                  templateStatus: {
                     EDIT: 'Tryb edycji',
                     NOT_PUBLISHED: 'Nieopublikowany',
                     PUBLISHED: 'Opublikowany',
                  },
                  templateVersion: {
                     NOT_PUBLISHED: {
                        specific: 'zapisano: {{date}}',
                     },
                     PUBLISHED: {
                        default: 'szablon podstawowy',
                        specific: 'wersja: {{date}}',
                     },
                  },
               },
            },
            tabName: 'Ustawienia ogólne',
         },
         healthcareProvider: {
            chooseLogoFile: 'Wybierz plik z rozszerzeniem .svg, .png lub .jpg',
            failedToFetchHealthcareProviderData: 'Nie udało się pobrać danych palcówki',
            invalidNip: 'Nieprawidłowy NIP',
            invalidRegon: 'Nieprawidłowy nr REGON',
            logo: 'Logo',
            noData: 'Brak danych',
            organization: {
               addScopeOfProvidedServices: 'Dodaj wiersz tabeli',
               codeMustBeUniqueWithinOrganization: 'Podany kod musi być unikalny w ramach podmiotu.',
               editHealthcareFacilityData: 'Edytuj dane zakładu leczniczego',
               editHealthcareFacilityLocationData: 'Edytuj dane komórki organizacyjnej',
               editHealthcareFacilityUnitData: 'Edytuj dane jednostki organizacyjnej',
               editOrganizationData: 'Edytuj dane podmiotu',
               failedToFetchHealthcareFacility: 'Nie udało się pobrać danych zakładu leczniczego.',
               failedToFetchHealthcareFacilityLocation: 'Nie udało się pobrać danych komórki organizacyjnej.',
               failedToFetchHealthcareFacilityUnit: 'Nie udało się pobrać danych jednostki organizacyjnej.',
               failedToFetchHealthcareOrganization: 'Nie udało się pobrać danych zakładu leczniczego.',
               healthcareFacilityDataChanged: 'Dane zakładu leczniczego zostały zmienione.',
               healthcareFacilityLocationData: 'Dane komórki organizacyjnej',
               healthcareFacilityLocationDataChanged: 'Dane komórki zostały zmienione.',
               healthcareFacilityParentData: 'Dane zakładu nadrzędnego',
               healthcareFacilityUnitData: 'Dane jednostki organizacyjnej',
               healthcareFacilityUnitDataChanged: 'Dane jednostki zostały zmienione.',
               healthcareFacilityUnitParentData: 'Dane jednostki nadrzędnej',
               insertSpecialty: 'Uzupełnij specjalizację',
               leavingPrompt: {
                  message:
                     'Istnieją niezapisane dane niezbędne dla podmiotu.\nCzy na pewno chcesz wyjść i utracić te dane?',
                  title: 'Wyjdź z edycji danych podmiotu',
               },
               locationCode: 'Kod resortowy VII: {{locationCode}}',
               locationCodeValidationMessage: 'Powinien być z zakresu 001 do 9999',
               myOrganization: 'Mój podmiot',
               noAssignHealthcareFacilityLocation: 'Brak przypisanych komórek organizacyjnych.',
               noAssignHealthcareFacilityUnit: 'Brak przypisanych jednostek organizacyjnych.',
               organizationDataChanged: 'Dane podmiotu zostały zmienione.',
               registerBookNumber: 'Numer księgi rejestrowej',
               registeringAuthority: 'Organ prowadzący rejestr',
               regon: 'REGON',
               regonNumber: 'REGON: {{regonNumber}}',
               resortCode: {
                  eight: 'Kod resortowy VIII',
                  five: 'Kod resortowy V',
                  nine: 'Kod resortowy IX',
                  seven: 'Kod resortowy VII',
                  ten: 'Kod resortowy X',
               },
               scopeOfProvidedServices: 'Zakres udzielanych świadczeń',
               searchByCodeOrName: 'Wyszukaj po kodzie lub nazwie...',
               tabName: 'Dane podmiotu',
               taxIdentifier: 'NIP',
               unitCode: 'Kod resortowy V: {{unitCode}}',
               unitCodeValidationMessage: 'Powinien być z zakresu 01 do 999',
               usingHealthcareFacilityAddressData: 'Użyj adresu zakładu',
               usingHealthcareFacilityContactData: 'Użyj danych kontaktowych zakładu',
               usingHealthcareFacilityUnitAddressData: 'Użyj adresu jednostki',
               usingHealthcareFacilityUnitContactData: 'Użyj danych kontaktowych jednostki',
               usingHealthcareOrganizationAddressData: 'Użyj adresu podmiotu',
               usingHealthcareOrganizationContactData: 'Użyj danych kontaktowych podmiotu',
            },
            practice: {
               cannotImportGroupPracticeFromRpwdl: 'Import danych z RPWDL dla praktyk grupowych jest niemożliwy.',
               chooseMedicalChamber: 'Wybierz organ prowadzący rejestr',
               dataImportFromRpwdlEndedWithError: 'Import danych z RPWDL zakończył się błędem.',
               dataImportFromRpwdlWasSuccessful: 'Import danych z RPWDL przebiegł pomyślnie.',
               doesNotAppearOnAStamp: '(nie widnieje na pieczątce)',
               editPracticeData: 'Edytuj dane praktyki',
               failedToFetchServiceProvidingLocation: 'Nie udało się pobrać danych miejsca udzielania świadczeń.',
               fetchingMedicalChambers: 'Pobieranie organów prowadzących rejestr',
               getHealthcarePracticeFormRpwdl: 'Pobierz dane praktyki z rejestru',
               incorrectRegistrationInformationWasEntered:
                  'Nie znaleziono podanego numeru księgi rejestrowej zgodnego z wybranym organem prowadzącym rejestr.',
               invalidRegisterBookNumber: 'Nie prawidłowy number księgi rejestrowej',
               leavingPrompt: {
                  message:
                     'Istnieją niezapisane dane niezbędne dla praktyki.\nCzy na pewno chcesz wyjść i utracić te dane?',
                  title: 'Wyjdź z edycji danych praktyki',
               },
               medicalChamber: 'Organ prowadzący rejestr',
               myPractice: 'Moja praktyka',
               noInfoServiceProvidingLocationFromRpwdl:
                  'Brak informacji o miejscu udzielania świadczeń w RPWDL. Po zapisaniu formularza utworzymy domyślne na bazie podanych danych praktyki.',
               noRequiredDataForServiceProvidingLocationFor:
                  'Brakuje wszystkich wymaganych danych dla miejsc udzielania świadczeń o następujących kodach: {{locationCodes}}.',
               overwritePracticeDataMessage:
                  'Zapis danych spowoduje nadpisanie aktualnych danych praktyki. Czy chcesz zapisać dane zaimportowane z RPWDL?',
               savingPracticeData: 'Zapisujesz dane praktyki',
               serviceProvidingLocation: 'Miejsce udzielania świadczeń',
               skipAddressInStamp: 'Nie pokazuj tego adresu w pieczątce praktyki',
               tabName: 'Dane praktyki',
               takenFromServiceProvidingLocationRegistry: 'Pobrane z rejestru miejsca udzielania świadczeń',
               tooManyQueriesToRpwdl: 'Zbyt duża liczba zapytań do RPWDL. Spróbuj ponownie za kilkanaście minut.',
               updatePracticeData: 'Zapisz dane praktyki',
               updatePracticeDataSuccess: 'Dane praktyki zostały zmienione.',
               validationWarningCodes: {
                  PRACTICE_MEDICAL_CHAMBER_MISMATCH: 'Organ rejestrowy jest inny niż zapisany w certyfikacie P1.',
                  PRACTICE_REGISTER_BOOK_NUMBER_MISMATCH:
                     'Numer księgi rejestrowej jest niezgodny z danymi zapisanymi w certyfikacie P1.',
               },
               verifyServiceProvidingLocationDataCorrectness:
                  'Zweryfikuj poprawność danych wymienionych miejsc udzielania świadczeń.',
            },
            registerBookNumber: 'Numer księgi rejestrowej',
            regon: 'REGON',
            taxIdentifier: 'NIP',
         },
         nfzSettings: {
            afterSaveEwusOrEzwmLoginGoToNfzLogin:
               'Aby zalogować się do eWUŚ i/lub eZWM uzupełnij dane integracji i przejdź do zakładki <link />.',
            areYourSureRemovingSenderCode:
               'Czy na pewno chcesz usunąć kod nadawcy dla eZWM? eZWM nie będzie działał bez tego kodu',
            automaticEwusStatusVerification: 'Automatyczna weryfikacja eWUŚ',
            cannotFetchNfzDepartments: 'Nie udało się pobrać oddziałów NFZ',
            chooseContractingPartyType: 'Wybierz typ kontrahenta',
            contractingPartyType: 'Typ kontrahenta',
            contractingPartyTypeOptions: {
               person: 'Osoba personelu',
               provider: 'Świadczeniodawca',
            },
            department: 'Oddział',
            ewusAutomaticStatusCheckTurnedOff: 'Wyłączono automatyczną weryfikację eWUŚ',
            ewusConfigurationWasSaved:
               'Zapisano konfigurację połączenia z systemem eWUŚ. Aby zalogować się do systemu przejdź do zakładki <link />.',
            ewusIntegrationTurnedOff: 'Wyłączono integrację z eWUŚ',
            ezwmConfigurationWasSaved:
               'Zapisano konfigurację połączenia z systemem eZWM. Aby zalogować się do systemu przejdź do zakładki <link />.',
            failedToFetchNfzConfiguration: 'Nie powiodło się pobranie konfiguracji NFZ',
            fetchingNfzDepartments: 'Pobieranie oddziałów NFZ',
            incorrectSenderCode:
               'Kod powinien mieć dokładnie 8 znaków i mieć tylko litery A-Z bez polskich znaków oraz cyfry.',
            integrationConfigurationAvailableOnceNfzDataIsEntered:
               'Ustawienia integracji są dostępne po uzupełnieniu danych integracji NFZ.',
            integrationSettings: 'Ustawienia integracji',
            integrationWithEwusSystem: 'Integracja z systemem eWUŚ',
            nfzIntegration: 'Integracja NFZ',
            nfzIntegrationDataWasSaved: 'Zapisano ustawienia integracji z NFZ.',
            nfzLogin: 'Logowanie NFZ',
            nfzSettings: 'Ustawienia NFZ',
            providerCode: 'Kod świadczeniodawcy',
            remove: 'Usuń',
            removeCode: 'Usuń kod',
            removeSenderCode: 'Usuwasz kod nadawcy',
            save: 'Zapisz',
            senderCodeForEzwm: 'Kod nadawcy dla eZWM',
            senderCodeRemoveSuccess:
               'Usunięto kod nadawcy eZWM. Wystawianie zleceń elektronicznych jest teraz niemożliwe.',
            senderCodeRequiredForEzwm: 'Wymagany do działania eZWM. Kod nadawcy generujemy na portalu zleceń.',
         },
         patientPhoneNotification: {
            notificationToggle: {
               appointmentCancellationToggle: 'Dodaj możliwość odwołania wizyty przez SMS',
               appointmentCancellationTokenInConfirmationToggleSaveOff: 'Dezaktywowano odwołanie wizyty przez SMS.',
               appointmentCancellationTokenInConfirmationToggleSaveOn: 'Aktywowano odwołanie wizyty przez SMS.',
               appointmentCancellationTokenInConfirmationToggleTooltip:
                  'Włączenie możliwości odwoływania przez pacjentów rezerwacji poprzez odpowiedź na wiadomość o potwierdzeniu rezerwacji',
               appointmentCancellationTokenInReminderToggleTooltip:
                  'Włączenie możliwości odwoływania przez pacjentów rezerwacji poprzez odpowiedź na wiadomość o przypomnieniu rezerwacji',
               appointmentConfirmationToggle: 'Wysyłaj wiadomości SMS z potwierdzeniem terminu wizyty',
               appointmentConfirmationToggleSaveOff: 'Dezaktywowano wysyłkę SMS-ów z potwierdzeniem terminu wizyty.',
               appointmentConfirmationToggleSaveOn: 'Aktywowano wysyłkę SMS-ów z potwierdzeniem terminu wizyty.',
               appointmentConfirmationToggleTooltip:
                  'Wiadomości SMS wysyłane do pacjentów z potwierdzeniem terminu wizyty o treści:',
               appointmentPatientCancellationToggle: 'Wysyłaj do pacjenta potwierdzenie odwołania wizyty',
               appointmentPatientCancellationToggleSaveOff:
                  'Dezaktywowano wysyłkę SMS-ów z potwierdzeniem odwołania wizyty.',
               appointmentPatientCancellationToggleSaveOn:
                  'Aktywowano wysyłkę SMS-ów z potwierdzeniem odwołania wizyty.',
               appointmentPatientCancellationToggleTooltip:
                  'SMS wysyłany do pacjenta z potwierdzeniem odwołania zaplanowanej wizyty o treści:',
               appointmentPractitionerCancellationToggle: 'Wysyłaj wiadomości SMS do specjalisty o odwołanej wizycie',
               appointmentPractitionerCancellationToggleSaveOff:
                  'Dezaktywowano wysyłkę SMS-ów do specjalisty o odwołanej wizycie.',
               appointmentPractitionerCancellationToggleSaveOn:
                  'Aktywowano wysyłkę SMS-ów do specjalisty o odwołanej wizycie.',
               appointmentPractitionerCancellationToggleTooltip:
                  'SMS wysyłane do specjalistów o odwołanej wizycie umówionej na dzień aktualny lub następny o treści:',
               appointmentPractitionerConfirmationToggle: 'Wysyłaj wiadomości SMS do specjalisty o nowej wizycie',
               appointmentPractitionerConfirmationToggleSaveOff:
                  'Dezaktywowano wysyłkę SMS-ów do specjalisty o nowej wizycie.',
               appointmentPractitionerConfirmationToggleSaveOn:
                  'Aktywowano wysyłkę SMS-ów do specjalisty o nowej wizycie.',
               appointmentPractitionerConfirmationToggleTooltip:
                  'SMS wysyłane do specjalistów o nowo zarejestrowanej wizycie na dzień aktualny lub następny o treści:',
               appointmentReminderToggle: 'Wysyłaj wiadomości SMS z przypomnieniem o terminie wizyty stacjonarnej',
               appointmentReminderToggleSaveOff: 'Dezaktywowano wysyłkę SMS-ów z przypomnieniem o terminie wizyty.',
               appointmentReminderToggleSaveOn: 'Aktywowano wysyłkę SMS-ów z przypomnieniem o terminie wizyty.',
               appointmentReminderToggleTooltip:
                  'Wiadomości SMS wysyłane do pacjentów z przypomnieniem o terminie wizyty o treści:',
               electronicDocumentIssuedToggle: 'Wysyłaj wiadomości SMS z kodami eDokumentów',
               electronicDocumentIssuedToggleSaveOff: 'Dezaktywowano wysyłkę SMS-ów z kodami eDokumentów.',
               electronicDocumentIssuedToggleSaveOn: 'Aktywowano wysyłkę SMS-ów z kodami eDokumentów.',
               electronicDocumentIssuedToggleTooltip:
                  'Wiadomości SMS wysyłane do pacjentów z kodami eRecepty i eSkierowania o treści:',
               videoConsultationReminderToggle: 'Wysyłaj wiadomości SMS z przypomnieniem o terminie wideokonsultacji',
               videoConsultationReminderToggleAdditionalInformationMap: {
                  noOptionsSelected: 'Brak powiadomień przypominających o wideokonsultacji',
                  onlyEarlyNotification: '24 godziny przed wizytą (brak możliwości odwołania SMS)',
                  onlyEarlyNotificationWithCancellation: '24 godziny przed wizytą (możliwość odwołania przez SMS)',
                  onlyLateNotification: '10 min przed wizytą (brak możliwości odwołania SMS)',
                  onlyLateNotificationWithCancellation: '10 min przed wizytą (możliwość odwołania przez SMS)',
               },
               videoConsultationReminderToggleTooltip:
                  'Wiadomości SMS wysyłane do pacjentów z przypomnieniem o terminie wideokonsultacji o treści:',
               waitlistProposedAppointmentResponseTokenToggle:
                  'Dodaj możliwość akceptacji lub odrzucenia terminu przez SMS',
               waitlistProposedAppointmentResponseTokenToggleSaveOff:
                  'Dezaktywowano akceptację lub odrzucenie proponowanego terminu przez SMS.',
               waitlistProposedAppointmentResponseTokenToggleSaveOn:
                  'Aktywowano akceptację lub odrzucenie proponowanego terminu przez SMS.',
               waitlistProposedAppointmentResponseTokenToggleTooltip:
                  'Włączenie możliwości akceptacji lub odrzucenia proponowanego terminu poprzez odpowiedź na wiadomość o wyznaczeniu proponowanego terminu rezerwacji.',
               waitlistProposedAppointmentToggle:
                  'Wysyłaj wiadomości SMS z informacją o wyznaczeniu proponowanego terminu wizyty dla pacjenta z listy rezerwowej',
               waitlistProposedAppointmentToggleSaveOff:
                  'Dezaktywowano wysyłkę SMS-ów z informacją o wyznaczeniu proponowanego terminu wizyty.',
               waitlistProposedAppointmentToggleSaveOn:
                  'Aktywowano wysyłkę SMS-ów z informacją o wyznaczeniu proponowanego terminu wizyty.',
               waitlistProposedAppointmentToggleTooltip:
                  'Wiadomości SMS wysyłane do pacjentów z informacją o wyznaczeniu proponowanego terminu o treści:',
            },
            packagesTable: {
               active: 'Aktywny',
               autoRefreshDate: 'Pakiet zostanie automatycznie odświeżony {{date}}',
               inactive: 'Nieaktywny',
               indefinitely: 'bezterminowo',
               name: 'Pakiet',
               noAutoRefreshDayOfMonth:
                  'Data odświeżenia pakietu zostanie ustawiona po wysłaniu pierwszej wiadomości SMS',
               remaining: 'Liczba pozostałych SMS',
               size: 'Liczba SMS w pakiecie',
               status: 'Status',
               utilized: 'Wykorzystany',
               validFrom: 'Data aktywacji',
               validTo: 'Data ważności',
            },
            purchaseSmsPackageButtonLabel: 'Kup pakiet SMS',
            purchaseSmsPackageTitle: 'Kup pakiet SMS',
            showInactive: 'Wyświetlaj nieaktywne',
            smsLimit: 'Limit SMS',
            smsLimitChanged: 'Zmieniono ustawienia limitu SMS',
            smsLimitInput: 'Maksymalna liczba SMS/miesiąc',
            smsLimitInputTooltip:
               'Potwierdzenie skutecznego wysłania wiadomości SMS przez operatora telekomunikacyjnego\n' +
               'może trwać do 24 godzin, dlatego rzeczywista liczba SMS może nieznacznie przekroczyć\n' +
               'ustawiony limit.',
            smsLimitPlaceholder: 'np. 1000',
            smsNoLimit: 'Bez limitu',
            smsPackages: 'Pakiety SMS',
            smsSettings: 'Ustawienia SMS',
            summary: 'Podsumowanie',
            summaryTable: {
               noData: 'Brak danych',
               orderedMessages: 'Liczba wysłanych SMS',
               yearAndMonth: 'Rok i miesiąc',
            },
            tabName: 'Wiadomości SMS',
            videoConsultationConfiguration: {
               form: {
                  cancellationAfterEarlyNotificationEnabled: 'Pozwól na odwołanie wizyty przez SMS',
                  cancellationAfterLateNotificationEnabled: 'Pozwól na odwołanie wizyty przez SMS',
                  earlyNotificationEnabled: '24 godziny przed wizytą',
                  label: 'Wysyłaj powiadomienie SMS',
                  lateNotificationEnabled: '10 minut przed wizytą',
                  validations: {
                     atLeastOneFieldIsRequired: 'Wymagane jest zaznaczenie co najmniej jednego pola.',
                  },
               },
               modal: {
                  actions: {
                     save: {
                        label: 'Zapisz',
                        successMessage:
                           'Zapisano zmiany parametrów wysyłki powiadomienia SMS o terminie wideokonsultacji.',
                     },
                  },
                  title: 'Edytuj ustawienia SMS wideokonsultacji',
               },
               update: 'Edytuj',
            },
         },
         patientPortal: {
            tabName: 'drEryk Pacjent',
         },
         practitioners: {
            confidentialAccessLevelUpdated: 'Poziom dostępu do danych poufnych został zmieniony.',
            confidentialDataAccess: {
               AUTHORIZED: 'Autoryzowany',
               MONITORED: 'Monitorowany',
            },
            defaultConfidentialResourceModeUpdate: {
               modalTitle: 'Zmieniasz domyślny tryb poufności danych',
               saved: 'Domyślny tryb poufności został zmieniony.',
               savedWithHistorical: 'Zmieniono domyślny tryb poufności i zastosowano do wizyt historycznych.',
               scope: {
                  allData: 'Zastosuj do wszystkich danych, także historycznych',
                  newDataOnly: 'Zastosuj wyłącznie do danych tworzonych od teraz',
               },
               scopeQuestion: 'W jakim zakresie chcesz zastosować tę zmianę?',
            },
            defaultDataMode: {
               CONFIDENTIAL: 'Poufny',
               NORMAL: 'Normalny',
            },
            editPractitionerPermissions: 'Edytuj uprawnienia',
            identificationType: {
               MEDICAL_LICENCE_NUMBER: 'NPWZ',
               PESEL: 'PESEL',
            },
            jobPositions: {
               ADMIN: 'Administrator',
               DOCTOR: 'Lekarz',
               RECEPTIONIST: 'Rejestrator',
            },
            modal: {
               addingMedicalData: 'Dodawanie danych medycznych',
               conductingPreInterview: 'Przeprowadzenie pre-wywiadu',
               conductingPreInterviewHint:
                  'Dostęp możliwy w przypadku nadanych uprawnień do dodawania danych medycznych.',
               email: 'E-mail',
               firstName: 'Imię',
               lastName: 'Nazwisko',
               leave: 'Wyjdź',
               leavingFromEditingContent:
                  'Czy chcesz przerwać edycję uprawnień użytkownika - <bold>{{practitionerName}}</bold>? Zmienione ustawienia zostaną utracone.',
               leavingFromEditingTitle: 'Wychodzisz z edycji uprawnień',
               medicalDataPreview: 'Podgląd danych medycznych',
               medicalLicenceNumber: 'NPWZ',
               permissions: 'Uprawnienia',
               pesel: 'PESEL',
               phoneNumber: 'Telefon',
               role: 'Rola',
               title: 'Edytuj uprawnienia użytkownika',
            },
            notApplicable: 'n/d',
            practitionerPermissionsUpdated: 'Zmiany zostały zapisane.',
            tabName: 'Użytkownicy',
            table: {
               authorizedConfidentialDataAccessDescription:
                  '<strong>Autoryzowany</strong> - wyświetlenie danych poufnych wymaga wcześniejszej zgody administratora.',
               confidentialDataAccess: 'Dostęp do danych poufnych',
               defaultConfidentialityLevelDescription:
                  'Określa domyślny poziom poufności danych medycznych wprowadzanych przez użytkownika. Dane wprowadzone w trybie normalnym zobaczą wszyscy użytkownicy z uprawnieniami do podglądu danych medycznych.',
               defaultDataMode: 'Domyślny tryb danych',
               email: 'E-mail',
               monitoredConfidentialDataAccessDescription:
                  '<strong>Monitorowany</strong> - użytkownik może samodzielnie wyświetlić dane poufne, a informacja o odkryciu danych zostanie zapisana w systemie.',
               phoneNumber: 'Telefon',
               practitioner: 'Użytkownik',
               role: 'Rola',
               specialty: 'Specjalizacja',
            },
         },
         serviceProvidingLocation: {
            cannotRemoveServiceProvidingLocation: 'Nie można usunąć MUŚ',
            cannotRemoveServiceProvidingLocationWithAssignedReceptionServices:
               'Nie można usunąć miejsca udzielania świadczeń, ponieważ jest ono wskazane jako miejsce realizacji <strong>{{count}} {{declensionForm}}</string>.',
            cannotRemoveServiceProvidingLocationWithAssignedReceptionServicesDeclensionMap: {
               accusative: 'usługi recepcyjnej',
               genitive: 'usług recepcyjnych',
               plural: 'usług recepcyjnych',
            },
            chooseOrSearchByCodeOrName: 'Wybierz lub wyszukaj po nazwie lub kodzie...',
            close: 'Zamknij',
            doYouWantRemoveYourServiceProvidingLocation:
               'Czy na pewno chcesz usunąć miejsce udzielania świadczeń {{serviceProvidingLocationName}} o kodzie identyfikującym {{locationCode}}?',
            invalidNameLength: 'Nazwa miejsca udzielania świadczeń może zawierać do {{maxLength}} znaków',
            locationCode: 'Kod identyfikujący',
            medicalField: 'Dziedzina',
            minimumOneServiceProvidingLocation:
               'Wymagane jest wskazanie co najmniej jednego miejsca udzielania świadczeń.',
            nameAndAddress: 'Nazwa i adres',
            nameAndContactData: 'Nazwa i dane kontaktowe',
            noServiceProvidingLocation: 'Brak miejsc udzielania świadczeń',
            removingServiceProvidingLocation: 'Usunięcie miejsca udzielania świadczeń',
            serviceProvidingLocationData: 'Dane miejsca udzielania świadczeń',
            serviceProvidingLocationWasRemoved: 'Miejsce udzielania świadczeń zostało usunięte.',
            updateServiceProvidingLocationData: 'Edytuj dane miejsca udzielania świadczeń',
            updateServiceProvidingLocationDataSuccess: 'Dane miejsca udzielania świadczeń zostały zapisane.',
            usingHealthcarePracticeDetails: 'Użyj danych praktyki',
         },
      },
   },
};

export const healthCareInstitutionTranslationKeys = createScopedTranslationKeys(
   translations.pl,
   'healthCareInstitution'
);
export const healthcareInstitutionCommonKeys = healthCareInstitutionTranslationKeys.common;
export const communicationWithP1TranslationKeys = healthCareInstitutionTranslationKeys.communicationWithP1;
export const healthcareProviderTranslationKeys = healthCareInstitutionTranslationKeys.healthcareProvider;
export const healthcarePracticeTranslationKeys = healthcareProviderTranslationKeys.practice;
export const healthcareOrganizationTranslationKeys = healthcareProviderTranslationKeys.organization;
export const serviceProvidingLocationTranslationKeys = healthCareInstitutionTranslationKeys.serviceProvidingLocation;
export const nfzSettingsTranslationKeys = healthCareInstitutionTranslationKeys.nfzSettings;
export const generalSettingsTranslationKeys = healthCareInstitutionTranslationKeys.generalSettings;
export const dataStorageTranslationKeys = healthCareInstitutionTranslationKeys.dataStorage;
export const certificatesFormTranslationKeys = communicationWithP1TranslationKeys.p1CertificatesForm;
export const practitionersTranslationKeys = healthCareInstitutionTranslationKeys.practitioners;
export const patientPhoneNotificationTranslationKeys = healthCareInstitutionTranslationKeys.patientPhoneNotification;
export const emergencyNotificationTranslationKeys = healthCareInstitutionTranslationKeys.emergencyNotification;
